import styled from 'styled-components';

const PlaceFirst = styled.div`
  order: -1;
`;

export {
  PlaceFirst,
};
